/* 🤖 this file was generated by svg-to-ts */
export const matIconFolderDelete: {
  name: 'folder-delete';
  data: string;
} = {
  name: 'folder-delete',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16.5 10V9h-2v1H12v1.5h1v4c0 .83.67 1.5 1.5 1.5h2c.83 0 1.5-.67 1.5-1.5v-4h1V10h-2.5zm0 5.5h-2v-4h2v4zM20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm0 12H4V6h5.17l2 2H20v10z"/></svg>`
};
